import { fetchQuery } from '@sequencehq/api'
import {
  Dashboardv20240509Api,
  dashboardv20240509Client
} from '@sequencehq/api/dashboard/v20240509'
import { MINUTES } from '@sequencehq/utils/dates'
import { apiQueryClient } from 'features/api/apiQueryClient'

type Options = {
  /**
   * When true, treat the cached entry as stale immediately and force a fresh
   * read from the network. Use this for moments where we know the integrations
   * data has changed (post-OAuth polling completes, configuration save,
   * manual refresh).
   */
  reload?: boolean
}

/**
 * Imperative cached read of the integrations endpoint. Routes through React
 * Query's cache via fetchQuery so repeat calls within `staleTime` are deduped —
 * several loaders fetch it during a single page load.
 *
 * Pass `{ reload: true }` to set staleTime to zero, which forces fetchQuery to
 * refetch from the network rather than serve the existing cache entry.
 */
export const getCachedIntegrations = (
  options?: Options
): Promise<Dashboardv20240509Api.GetIntegrations.IntegrationList | null> =>
  fetchQuery(
    apiQueryClient,
    dashboardv20240509Client.getIntegrations,
    undefined,
    { staleTime: options?.reload ? 0 : 1 * MINUTES }
  )
